__turbopack_context__.v({
  "content": "slider-module-scss-module__UiODha__content",
  "name": "slider-module-scss-module__UiODha__name",
  "position": "slider-module-scss-module__UiODha__position",
  "slide": "slider-module-scss-module__UiODha__slide",
  "sliderWrapper": "slider-module-scss-module__UiODha__sliderWrapper",
  "swiper": "slider-module-scss-module__UiODha__swiper",
});
